
import { Vue, Component } from 'vue-property-decorator';
import UserService from '@/services/user.service';
import { BASE_URL } from '@/common/constant';
import lazyInject from '@/di';
import { $delay } from '@/common/utils';
import ShopService from '@/services/shop.service';

@Component

export default class ReleaseGroundPusherModal extends Vue {
  title = '批量释放地推员';

  token: string | undefined = undefined;

  @lazyInject(ShopService)
  shopService!: ShopService;

  BASE_URL = BASE_URL;

  @lazyInject(UserService)
  userService!: UserService;

  uploading = false;

  total = 0;

  error = 0;

  visible = false;


  poiData = '';

  poiDoesNotExist = '';

  noGroundPusher = '';

  options: any = {
    headers: {
      AUTHORIZATION: '',
    },
  };

  afterClose() {
    this.visible = false;
  }

  init() {
    this.visible = true;
  }

  /**
   * 释放
   */
  async handleOk() {
    if (this.total === 0) {
      this.$message.error('请先导入POI');
      return;
    }
    try {
      const res = await this.shopService.shopBatchReleaseSubmit();
      if (res) {
        this.$message.success('释放成功');
        this.visible = false;
        this.total = 0;
        this.error = 0;
        this.poiData = '';
        this.poiDoesNotExist = '';
        this.noGroundPusher = '';
      }
    } catch (error) {
      this.$message.error('释放失败');
    }
  }

  handleCancel() {
    this.visible = false;
    this.total = 0;
    this.error = 0;
    this.poiData = '';
    this.poiDoesNotExist = '';
    this.noGroundPusher = '';
  }

  onCopySuccess() {
    this.$message.success('复制成功');
  }

  remove(type: string) {
    const all = this.poiData.split(',').map((item) => {
      return item;
    });
    let diff: any[] = [];
    switch (type) {
      case 'poiDoesNotExist': {
        const poiDoesNotExistList = this.poiDoesNotExist.split(',').map((item) => {
          return item;
        });
        diff = all.filter((item) => poiDoesNotExistList.indexOf(item) === -1);
        this.poiDoesNotExist = '';
        break;
      }

      default: {
        const noGroundPusherList = this.noGroundPusher.split(',').map((item) => {
          return item;
        });
        diff = all.filter((item) => noGroundPusherList.indexOf(item) === -1);
        this.noGroundPusher = '';
        break;
      }
    }
    this.poiData = diff.join(',');
    this.$message.success('移除成功');
  }

  created() {
    this.options.headers.AUTHORIZATION = this.userService.currentUser()?.token;
    this.token = this.userService.currentUser()?.token;
  }

  async downloadTemplate() {
    await this.shopService.shopBatchRelease();
  }

  async onDeltaImportChange(info: any) {
    if (info.file.status === 'uploading') {
      this.uploading = true;
    }
    if (info.file.status === 'error') {
      this.uploading = false;
      const { code, error } = info.file.response;
      if (code === 400) {
        this.$message.error(error);
        await $delay(1000);
        this.$router.push({
          path: '/login',
          query: {
            redirect: this.$route.fullPath,
          },
        });
      } else {
        this.$message.error(error);
      }
    }
    if (info.file.status === 'done') {
      const { data } = JSON.parse(info.file.xhr.response);
      const { total, staff_not_exist, not_exist } = data;
      // const newIds = data.data;
      this.total = 0;
      this.error = 0;
      this.poiData = '';
      this.poiDoesNotExist = '';
      this.noGroundPusher = '';
      let num = 0;
      if (staff_not_exist) {
        num += staff_not_exist.length;
        this.noGroundPusher = staff_not_exist.join(',');
      }
      if (not_exist) {
        num += not_exist.length;
        this.poiDoesNotExist = not_exist.join(',');
      }
      this.error = num;
      this.total = total;
    }
  }

  beforeUpload(file: { type: string; size: number }) {
    const isExcel =
      file.type === 'application/vnd.ms-excel' ||
      file.type ===
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
      file.type === 'text/csv';
    if (!isExcel) {
      this.$message.error('请上传 excel表格！');
    }
    const isLt5M = this.isLt5M(file as File);
    if (!isLt5M) {
      this.$message.error('文件必须小于5MB!');
    }
    return isExcel && isLt5M;
  }


  isLt5M(file: File) {
    return file.size / 1024 / 1024 < 5;
  }
}
